<ion-grid [style.height]="Height + 'px'" [style.min-height]="Height + 'px'">
    <ion-row *ngFor="let item of Data?.datasets">
        <ion-col>
            <h1>{{(item.data[0]|currencyFormatter)||'--'}}</h1>
            <p>{{item.label||'--'}}</p>
        </ion-col>
    </ion-row>
</ion-grid>